import { useStore } from "./useStore";

export const useExtractedImagesState = () => {

    const {
        selectedImages,
        addToSelectedImages,
        removeFromSelectedImages,
        resetSelectedImages,
        setDisplayImageManuals,
        displayImageManuals,
    } = useStore();

    return {
        selectedImages,
        addToSelectedImages: addToSelectedImages,
        removeFromSelectedImages: removeFromSelectedImages,
        resetSelectedImages,
        setDisplayImageManuals,
        displayImageManuals,
    }
}